import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { LoginSocialBarSdkData } from '@wix/thunderbolt-components';
import {
  LoginSocialBarPlatformProps,
  LoginSocialBarDefinition,
  LoginSocialBarCSSVars,
} from '../LoginSocialBar.types';

export const props = withCompInfo<
  LoginSocialBarPlatformProps,
  LoginSocialBarDefinition,
  LoginSocialBarPlatformProps
>()([], (_deps, carmiData) => {
  return carmiData;
});

export const css = withCompInfo<
  LoginSocialBarCSSVars,
  LoginSocialBarDefinition,
  LoginSocialBarCSSVars
>()([], (_deps, carmiCss) => {
  return carmiCss;
});

export const sdkData = withCompInfo<
  LoginSocialBarSdkData,
  LoginSocialBarDefinition,
  LoginSocialBarSdkData
>()([], (_deps, carmiSdkData) => {
  return carmiSdkData;
});

export default createComponentMapperModel({ props, css, sdkData });
